import React from 'react';
import { observer } from 'mobx-react';
import { Modal, Spin } from 'antd';
import AppStore from 'stores/App';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 0px !important;

    .ant-modal-header {
      background-color: #ffffff !important;
      padding: 20px 24px !important;

      .ant-modal-title {
        color: #05103a !important;
      }
    }

    .ant-modal-close > .ant-modal-close-x {
      color: #05103a !important;
    }

    .ant-modal-body {
      padding: 14px !important;
    }
  }
`;

const Loading = observer(() => {
  const isLoading = AppStore.isLoading.get();
  const message = isLoading ? AppStore.messages[0] : 'Loading';

  const handleAfterClose = () => {
    document.getElementsByTagName('body')[0].style = '';
  };

  return (
    <StyledModal
      title={message}
      centered
      footer={null}
      open={isLoading}
      afterClose={handleAfterClose}
    >
      <Spin size="large" /> Loading...
    </StyledModal>
  );
});

export default Loading;
